import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function StepcountNumberIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'PrimaryDefault', secondaryColor = 'White', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    const secondaryFillColor = themeContext.colors[secondaryColor];
    return (_jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [_jsx("path", { d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z", fill: primaryFillColor }), _jsx("path", { d: "M13.012 14.508H8.224v-1.106l4.34-6.202h1.918v6.048H15.7v1.26h-1.218V17h-1.47v-2.492zm0-1.26V8.6l-3.206 4.648h3.206z", fill: secondaryFillColor })] }));
}
//# sourceMappingURL=StepcountNumber.js.map